import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { LoadingService } from '../../shared/services/loading.service';
import { EditDialogComponent } from '../editDialog/editDialogComponent';
import { EditDialogInstance } from '../editDialog/editDialogService';
import { CustomAttributeDefinition, CustomAttributeDefinitionInput, CustomAttributeSection } from '../../shared/entities/customAttributes/customAttributes';
import { CustomAttributesService } from '../../shared/services/customAttributes/customAttributesService';
import { RolesService } from '../../shared/services/roles/roles.service';
import { EditSelectable } from '../../formControls/edit-select-form-control.component';

@Component({
  selector: 'app-custom-attribute-definition-dialog',
  templateUrl: './custom-attribute-definition-dialog.component.html',
  styleUrls: ['./custom-attribute-definition-dialog.component.scss']
})
export class CustomAttributeDefinitionDialogComponent
  implements EditDialogInstance {

  customAttributeDefinitionForm: FormGroup;
  customAttributeDefinition: CustomAttributeDefinition;
  nextIndex: number;
  entityType: any;
  customAttributeSectionId: string;

  typeOptions: EditSelectable[] = [ 
    { name: 'coreModuleModule.customAttributeDefinitionDialogComponent.type.string', id: 'STRING' },
    { name: 'coreModuleModule.customAttributeDefinitionDialogComponent.type.boolean', id: 'BOOLEAN' },
    { name: 'coreModuleModule.customAttributeDefinitionDialogComponent.type.dateTime', id: 'DATETIME' },
    { name: 'coreModuleModule.customAttributeDefinitionDialogComponent.type.number', id: 'NUMBER' } 
  ];
  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public loadingService: LoadingService,
    public customAttributeService: CustomAttributesService,
    private rolesService: RolesService
  ) {

    if (this.config.data) {
      this.customAttributeDefinition = this.config.data?.customAttributeDefinition;
      this.nextIndex = this.config.data?.nextIndex;
      this.entityType = this.config.data?.entityType;
      this.customAttributeSectionId = this.config.data?.customAttributeSectionId;
    }

    this.customAttributeDefinitionForm = new FormGroup({});
    this.customAttributeDefinitionForm.addControl('id', new FormControl());
    // add form controls
    this.customAttributeDefinitionForm.addControl('externalId', new FormControl());
    this.customAttributeDefinitionForm.addControl('sectionId', new FormControl(this.customAttributeSectionId, [Validators.required]));
    let entityFormControl = new FormControl(this.entityType, Validators.required);
    this.customAttributeDefinitionForm.addControl('entity', entityFormControl);
    this.customAttributeDefinitionForm.addControl('type', new FormControl(undefined, [Validators.required]));
    this.customAttributeDefinitionForm.addControl('label', new FormControl(undefined, [Validators.required]));
    let indexFormControl = new FormControl(this.nextIndex, Validators.required);
    this.customAttributeDefinitionForm.addControl('index', indexFormControl);
    if(!this.isAdmin()){ // admin can directly set the index
      indexFormControl.disable(); // disable the index field, as it is automatically set 
    }
    this.customAttributeDefinitionForm.addControl('key', new FormControl(undefined, [Validators.required]));
    this.customAttributeDefinitionForm.addControl('conversionExpression', new FormControl(undefined));
    

    if (this.customAttributeDefinition) {
      this.customAttributeDefinitionForm.patchValue(this.customAttributeDefinition);
      this.customAttributeDefinitionForm.get('sectionId')?.setValue(this.customAttributeDefinition?.customAttributeSection?.id);
    }

  }


  onConfirm(editDialogComponent: EditDialogComponent<any>): void {
    this.loadingService.setLoading(true);
    let customAttributeDefinitionInput = new CustomAttributeDefinitionInput(this.customAttributeDefinitionForm.getRawValue());
    if (this.customAttributeDefinition) {
      this.customAttributeService.updateDefinition(customAttributeDefinitionInput, (result: any) => {
        this.loadingService.setLoading(false);
        this.ref.close(result?.data?.updateCustomAttributeDefinition?.id);
      });
    } else {
      this.customAttributeService.createDefinition(customAttributeDefinitionInput, (result: any) => {
        this.loadingService.setLoading(false);
        this.ref.close(result?.data?.createCustomAttributeDefinition?.id);
      });
    }
  }

  onReject(editDialogComponent: EditDialogComponent<any>): void {
    this.ref.close(false);
  }

  getEditForm(): FormGroup {
    return this.customAttributeDefinitionForm;
  }

  isAdmin(): boolean {
    return this.rolesService.hasRole('framework_tenants_manage');
  }

}
